import { Price } from '@src/components';
import { ItemRow } from '@src/components/ItemRow/ItemRow';

type PriceRowProps = {
  label: string;
  price?: number;
  currency?: string;
  className?: string;
  priceClassName?: string;
};

export function PriceRow({
  label,
  price = 0,
  currency = 'usd',
  className,
  priceClassName,
}: Readonly<PriceRowProps>) {
  return (
    <ItemRow
      className={className}
      label={label}
      value={
        <Price
          price={price ?? 0}
          currency={currency}
          className={priceClassName}
        />
      }
    />
  );
}
